const STATUS_STYLES = {
  IN_SEQUENCE: "bg-green-100 text-green-800",
  REPLIED: "bg-blue-100 text-blue-800",
  MANUAL_STOP: "bg-yellow-100 text-yellow-800",
  DO_NOT_SEND: "bg-red-100 text-red-800",
  NO_REPLY: "bg-gray-100 text-gray-800",
  BLOCKED: "bg-orange-100 text-orange-800",
};

const STATUS_LABELS = {
  IN_SEQUENCE: "In Sequence",
  REPLIED: "Replied",
  MANUAL_STOP: "Manual Stop",
  DO_NOT_SEND: "Do Not Send",
  NO_REPLY: "No Reply",
  BLOCKED: "Blocked",
};

export default function LeadStatusBadge({ status }) {
  const style = STATUS_STYLES[status] || "bg-gray-100 text-gray-800";
  const label = STATUS_LABELS[status] || status;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style}`}
    >
      {label}
    </span>
  );
}
